export const CONST_LAND_PATH = 'https://puzzlebot.top';
export const CONST_HOME_PATH = '/';
export const CONST_RUBRIC_PATH = '/rubric';
export const CONST_ARTICLE_PATH = '/article';
export const CONST_FILTERED_ARTICLES_PATH = '/filtered-articles';
export const CONST_ERROR_PAGE_PATH = '/error-page';
export const CONST_ADMIN_PATH = '/help-pbt-admin';
export const DEFAULT_LANGUAGE_CODE = 'ru';
export const DEFAULT_USER_ROLE = 'user';
export const ADMIN_USER_ROLE = 'admin';
